// extracted by mini-css-extract-plugin
export default {"container":"homepage_container__IFloK","title":"homepage_title__0H3f1","img":"homepage_img__9FrOg"};